// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3cJrA","forms":"Login_forms__cA3yc"};